import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/data/site";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {/* 24/7 Notruf (pulsing) */}
      <a
        href={`tel:${SITE.phoneIntl}`}
        data-testid="floating-notruf"
        className="group relative flex items-center gap-2 rounded-full bg-[#FF3B30] pl-4 pr-5 py-3 text-white shadow-lg"
      >
        <span className="absolute inset-0 rounded-full bg-[#FF3B30] opacity-70 animate-ping" style={{ animationDuration: "2s" }} />
        <Phone className="relative h-5 w-5" />
        <span className="relative font-body text-sm font-bold uppercase tracking-wide">24/7 Notruf</span>
      </a>

      {/* WhatsApp */}
      <motion.a
        href={SITE.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg"
        aria-label="WhatsApp Kontakt"
      >
        <MessageCircle className="h-7 w-7" />
      </motion.a>
    </div>
  );
}
